/**
 * ESM re-export shim for the byte-identical UMD `contracts.js`.
 *
 * `contracts.js` uses no import/export (so the SAME file loads as a window
 * <script> on desktop and via CJS require in the main process). Frontend code
 * wants clean named imports, so this thin module imports it for its side-effect
 * (which populates globalThis.InquisitorContracts) and re-exports the surface.
 */
import './contracts.js';

const C = globalThis.InquisitorContracts;

export const S = C.S;
export const optional = C.optional;
export const nullable = C.nullable;
export const passthrough = C.passthrough;
export const validate = C.validate;
export const DATACHANNEL = C.DATACHANNEL;
export const IPC = C.IPC;
export const EXTENSION_WS = C.EXTENSION_WS;
export const getDataChannelContract = C.getDataChannelContract;
export const boundaryMode = C.boundaryMode;
export const validateBoundary = C.validateBoundary;
export const validateIpc = C.validateIpc;
export const validateExtensionWs = C.validateExtensionWs;
export const normalizeBlockDomain = C.normalizeBlockDomain;
export const buildUrlBlockPattern = C.buildUrlBlockPattern;

export default C;
